export default __webpack_public_path__ + "static/media/027-shower.97607972.svg";